<template>
	<div class="containerMain">
		<title-bar :topTitle="true" topTitleText="Colegios"/>
		<div class="col inner" v-if="schools">
			<div v-if="visit && schools && schools.length > 0" class="col between innerRubric sd">
				<b-table responsive class="category all" striped hover :items="schools" :fields="tableFields">
				</b-table>
			</div>
			<h1 v-else-if="visit && (!schools || schools.length == 0)" class="mt-5">
				No hay datos para esta vista.
			</h1>
			<h1 v-else class="mt-5">
				Selecciona una visita.
			</h1>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				schoolCode: {
					label: 'Clave colegio',
					sortable: true
				},
				schoolName: {
					label: 'Nombre de colegio',
					sortable: true
				},
				level: {
					label: 'Nivel',
					sortable: true
				},
				language: {
					label: 'Idioma',
					sortable: true
				},
				visit: {
					label: 'Visita',
					sortable: true
				},
				startDate: {
					label: 'Fecha inicio',
					sortable: true
				},
				endDate: {
					label: 'Fecha fin',
					sortable: true
				},
				average: {
					label: 'Promedio',
					sortable: true
				},
				emotionalEnvironment: {
					label: 'Ambiente Emocional',
					sortable: true
				},
				academicProcess: {
					label: 'Proceso Académico',
					sortable: true
				},
				deepLearning: {
					label: 'Aprendizaje profundo',
					sortable: true
				},
				expertLearning: {
					label: 'Aprendizaje experto',
					sortable: true
				}
			}
		};
	},
	computed: {
		schools () {
			if (!this.$store.state.admin.summary) return null;
			let academicYear = this.$store.state.persistent.academicYear;
			let visit = this.$store.state.persistent.visit;
			return this.$store.state.admin.summary.map((item) => {
				item.schoolId = item.school.id;
				item.schoolCode = item.school.code;
				item.schoolName = item.school.schoolName;
				item.level = item.academicLevelName[0].toUpperCase() + item.academicLevelName.slice(1);
				item.language = item.languageName[0].toUpperCase() + item.languageName.slice(1);
				item.visit = visit.value;
				item.startDate = this.getHumanDate(academicYear.startDate);
				item.endDate = this.getHumanDate(academicYear.endDate);
				item.schoolName = item.school.name;
				item.average = item.schoolAverage ? parseFloat(item.schoolAverage).toFixed(2) : 0;
				item.emotionalEnvironment = item.categories[0] ? parseFloat(item.categories[0].percentage).toFixed(2) : 0;
				item.academicProcess = item.categories[1] ? parseFloat(item.categories[1].percentage).toFixed(2) : 0;
				item.deepLearning = item.categories[2] ? parseFloat(item.categories[2].percentage).toFixed(2) : 0;
				item.expertLearning = item.categories[3] ? parseFloat(item.categories[3].percentage).toFixed(2) : 0;
				return item;
			});
		},
		visit () {
			return this.$store.state.persistent.visit ?
				this.$store.state.persistent.visit.value :
				'';
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		goToRoute (item) {
			this.$store.dispatch('setSchoolMenu', {
				schoolId: item.item.schoolId,
				name: item.item.name
			});
			this.$router.push(`/coaching/admin/schools/${item.item.schoolId}/syntheses`);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/admin/AdminSummary.vue